import constants from '../services/constants';
import { atom } from 'recoil';
import { ISelectedTeamMember } from 'atoms/selectedTeamMemberAtom';

const updatedTeamMemberAtom = atom<ISelectedTeamMember | null>({
    key: constants.updatedTeamMemberAtom,
    default: null,
});

export default updatedTeamMemberAtom;